export default "__VITE_ASSET__ALNxyHNn__"